var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('order',{attrs:{"order":_vm.offerOrder[0]}})],1),_c('v-col',[_c('tools',{attrs:{"deal":_vm.deal_view}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }